import { useNavigate } from "react-router-dom";
import LogoFooter from "../components/LogoFooter";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useState } from "react";

import Inauguracoes from "./Conquistas/inauguracoes";
import ConquistasInternas from "./Conquistas/conquistasInternas";
import Fade from "../components/Fade";

export default function Conquistas() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [subStep, setSubStep] = useState(1);

  const stepsConfig = {
    1: {
      title: "Últimas inaugurações",
      component: Inauguracoes,
    },
    2: {
      title: "Conquistas Internas",
      component: ConquistasInternas,
    },
  };

  const maxSubSteps = {
    1: 3,
    2: 5,
  };

  const nextStep = () => {
    if (subStep < maxSubSteps[step]) {
      setSubStep((s) => s + 1);
      return;
    }

    const next = step >= 2 ? 1 : step + 1;

    setStep(next);
    setSubStep(1);
  };

  const prevStep = () => {
    if (subStep > 1) {
      setSubStep((s) => s - 1);
      return;
    }

    const prev = step <= 1 ? 2 : step - 1;

    setStep(prev);
    setSubStep(maxSubSteps[prev]);
  };

  const StepComponent = stepsConfig[step].component;
  const title = stepsConfig[step].title;

  return (
    <div className="flex flex-col min-h-screen">
      {/* HEADER */}
      <header className="bg-blue text-white py-10 px-16">
        <h1 className="text-5xl font-bold">{title}</h1>
      </header>

      <Fade key={`${step}-${subStep}`}>
        <StepComponent subStep={subStep} />
      </Fade>

      <div className="flex-1" />

      {/* FOOTER/NAV */}
      <div className="flex items-center justify-between px-16 pb-10">
        <button
          onClick={() => navigate(-1)}
          className="min-w-[200px] py-4 border-2 border-deepBlue text-deepBlue px-12 rounded-2xl text-3xl font-semibold transition hover:bg-deepBlue hover:text-white"
        >
          Voltar
        </button>

        <div className="flex items-center gap-8">
          <div
            onClick={prevStep}
            className="w-16 h-16 bg-blue/20 rounded-full flex items-center justify-center cursor-pointer transition hover:bg-blue/30"
          >
            <FiChevronLeft className="text-4xl text-deepBlue" />
          </div>

          <div
            onClick={nextStep}
            className="w-16 h-16 bg-blue/20 rounded-full flex items-center justify-center cursor-pointer transition hover:bg-blue/30"
          >
            <FiChevronRight className="text-4xl text-deepBlue" />
          </div>
        </div>

        <LogoFooter />
      </div>
    </div>
  );
}
